import { Component } from '@angular/core';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { deployUrl } from '../../core/utils/deploy-url';

@Component({
  selector: 'cwo-loader',
  standalone: true,
  imports: [LottieComponent],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss'
})
export class LoaderComponent {
  options: AnimationOptions = {
    path: deployUrl('assets/animations/loader.json'),
    loop: true,
    autoplay: true
  };

}
